import { InferType } from 'yup'

import { validationSchema } from './validationSchema'

export type AccountFormValues = InferType<typeof validationSchema>

export enum AccountActionType {
  Donate = 'donate',
  Plant = 'plant'
}

export enum ProfileVisibility {
  Private = 'Private',
  Public = 'Public'
}
